import React from "react";
import "../containers/MainAppContainer.css";
import { translations } from "../containers/assets/translations";
import { B2B_PROXY } from "../containers/assets/config";
import Modal from "react-responsive-modal";

export default class VoucherDisplay extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Modal
        open={this.props.displayVouchers}
        onClose={this.props.onCloseDisplayVouchers}
        center
      >
        <div>
          {this.props.hasPersonVouchers ? (
            <div className="col-md-12 head">
              <div className="col-md-3">
                {translations[this.props.lang]["Ticket Number"]}
              </div>

              <div className="col-md-3">
                {translations[this.props.lang]["Surname Name"]}
              </div>
              {!this.props.hasCancelledTickets ? (
                <div className="col-md-3">
                  {translations[this.props.lang]["Download Boarding Card Pdf"]}
                </div>
              ) : (
                <div className="col-md-3">
                  {translations[this.props.lang]["Status"]}
                </div>
              )}
              <div className="col-md-3">
                {translations[this.props.lang]["Print Boarding Card"]}{"\t\t\t\t"}
              </div>
            </div>
          ) : null}
          {this.props.boardingCardVouchers.map((voucher, index) => {
            if (!this.props.hasCancelledTickets) {
              if (!voucher.hasOwnProperty("RegistrationNumber")) {
                return (
                  <div
                    className="col-md-12 col-xs-12 resultsRTicks"
                    key={voucher.BookID}
                  >
                    <div className="col-md-3 col-xs-3 resultVouch">
                      {voucher.TicketNumber}
                    </div>

                    <div className="col-md-3 col-xs-3 resultVouch">
                      {voucher.Surname} {voucher.Name}
                    </div>

                    <div className="col-md-3 col-xs-3 resultVouchbtn">
                      <a
                        href={
                          B2B_PROXY +
                          "/boardpasses/" +
                          voucher.BookID +
                          voucher.TicketNumber +
                          ".pdf"
                        }
                        target="_blank"
                      >
                        {translations[this.props.lang]["Download"]} {"\t\t\t\t"}
                        <span className="glyphicon glyphicon-download-alt" />
                      </a>
                    </div>          
                    {this.props.IssueTickets && this.props.IssueTickets[index] && (
                      <div className="col-md-3 col-xs-3 resultVouchbtn" key={index}>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.props.writeToSelectedPrinter(atob(this.props.IssueTickets[index].Blob));
                          }}
                        >
                          {translations[this.props.lang]["Print Thermal Ticket"]}{"\t\t\t\t"}
                        </a>
                      </div>
                    )}
                  </div>
                );
              } else {
                return (
                  <div key={voucher.BookID}>
                    <div className="col-md-12 head HeaderVoucherVeh">
                      <div className="col-md-2">
                        {translations[this.props.lang]["Ticket Number"]}
                      </div>

                      <div className="col-md-3">
                        {translations[this.props.lang]["Driver Name"]}
                      </div>
                      <div className="col-md-2">
                        {translations[this.props.lang]["Plates"]}
                      </div>
                      <div className="col-md-2">
                        {" "}
                        {
                          translations[this.props.lang][
                            "Download Boarding Card Pdf"
                          ]
                        }
                      </div>
                      <div className="col-md-2">
                        {translations[this.props.lang]["Print Boarding Card"]}{"\t\t\t\t"}
                      </div>
                    </div>
                    <div
                      className="col-md-12 col-xs-12 resultsRTicks"
                      key={voucher.BookID}
                    >
                      <div className="col-md-2 col-xs-3 resultVouch">
                        {voucher.TicketNumber}
                      </div>

                      <div className="col-md-3 col-xs-4 resultVouch">
                        {voucher.DriverName}
                      </div>
                      <div className="col-md-2 col-xs-1 resultVouch">
                        {voucher.RegistrationNumber}
                      </div>
                      <div className="col-md-2 col-xs-4 resultVouchbtn">
                        <a
                          href={
                            B2B_PROXY +
                            "/boardpasses/" +
                            voucher.BookID +
                            voucher.TicketNumber +
                            ".pdf"
                          }
                          target="_blank"
                        >
                          {translations[this.props.lang]["Download"]}
                          {"\t\t\t\t"}
                          <span className="glyphicon glyphicon-download-alt" />
                        </a>
                      </div>
                      {this.props.IssueTickets && this.props.IssueTickets[index] && (
                      <div className="resultVouchbtn" key={index}>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.props.writeToSelectedPrinter(atob(this.props.IssueTickets[index].Blob));
                          }}
                        >
                          {translations[this.props.lang]["Print Thermal Ticket"]}{"\t\t\t\t"}
                        </a>
                      </div>
                    )}
                    </div>
                  </div>
                );
              }
            } else {
              if (!voucher.hasOwnProperty("RegistrationNumber")) {
                return (
                  <div
                    className="col-md-12 col-xs-12 resultsRTicks"
                    key={voucher.BookID}
                  >
                    <div className="col-md-3 col-xs-4 resultVouch">
                      {voucher.TicketNumber}
                    </div>

                    <div className="col-md-3 col-xs-4 resultVouch">
                      {voucher.Surname} {voucher.Name}
                    </div>
                    <div className="col-md-4 col-xs-4 resultVouch">
                      {translations[this.props.lang]["Cancelled"]}
                    </div>
                  </div>
                );
              } else {
                return (
                  <div key={voucher.BookID}>
                    <div className="col-md-12 head HeaderVoucherVeh">
                      <div className="col-md-2">
                        {translations[this.props.lang]["Ticket Number"]}
                      </div>

                      <div className="col-md-4">
                        {translations[this.props.lang]["Driver Name"]}
                      </div>
                      <div className="col-md-2">
                        {translations[this.props.lang]["Plates"]}
                      </div>
                    </div>
                    <div
                      className="col-md-12 col-xs-12 resultsRTicks"
                      key={voucher.BookID}
                    >
                      <div className="col-md-2 col-xs-3 resultVouch">
                        {voucher.TicketNumber}
                      </div>

                      <div className="col-md-4 col-xs-4 resultVouch">
                        {voucher.DriverName}
                      </div>
                      <div className="col-md-2 col-xs-1 resultVouch">
                        {voucher.RegistrationNumber}
                      </div>
                      <div className="col-md-4 col-xs-4 resultVouch">
                        {translations[this.props.lang]["Cancelled"]}
                      </div>
                    </div>
                  </div>
                );
              }
            }
          })}
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VoucherDisplay.js